// extracted by mini-css-extract-plugin
export default {"group":"Tooltip--group--RhVw1","info-box":"Tooltip--info-box---0mNo","infoBox":"Tooltip--info-box---0mNo","value":"Tooltip--value--S2pLE"};